export const LOCAL_STORAGE_ALERT_KEY = 'local-storage-alert';
